module.exports = __webpack_public_path__ + "img/aset jurusan wa 5.1f260c75.png";